import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.highlightToday();
  }

  highlightToday() {
    const today = new Date().toDateString();
    const cellDate = new Date(`${this.element.dataset.date}T00:00`).toDateString();

    if (today === cellDate) {
      this.element.classList.add('today');
      this.element.setAttribute('title', 'Today');
      this.element.setAttribute('aria-label', 'Today');
    } else {
      this.element.classList.remove('today');
      this.element.removeAttribute('title');
      this.element.removeAttribute('aria-label');
    }
  }
}
